module.exports = __webpack_public_path__ + "images/newerp_icon1.1792033684119.png";